<% for (var layerId in layers) { %>
    <li class="vector-map-settings-popup__choice">
        <input type="checkbox" data-map-settings-features-control
                id="map-settings-<%= layers[layerId].tilejson.name %>"
                value="<%= layers[layerId].tilejson.name %>"
                name="map_setting_<%= layers[layerId].tilejson.name %>"
                <% if(selected.has(layers[layerId].tilejson.name)) { %>checked<% } %>>
        <label for="map-settings-<%= layers[layerId].tilejson.name %>"><i class="icon icon-bullet-01 feature-<%= layers[layerId].tilejson.name %>"></i> <%= layers[layerId].tilejson.description %></label>
    </li>
<% } %>

